/*import React from "react";
import CustomerTable from "../components/CustomerTable";

const CustomersPage: React.FC = () => {
    return (
        <div>
            <h2>Manage Customers</h2>
            <CustomerTable />
        </div>
    );
};

export default CustomersPage;*/

import React from "react";
import CustomerTable from "../components/CustomerTable";
import Layout from "../components/Layout";

const CustomersPage: React.FC = () => {
    return (
        <Layout>
            <CustomerTable />
        </Layout>
    );
};

export default CustomersPage;

